var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "signup__main"
  }, [_c('div', {
    staticClass: "backToLogin"
  }, [_vm.step === 'form' ? _c('nuxt-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('span', {
    on: {
      "click": function ($event) {
        return _vm.track('signup', 'end', 'login');
      }
    }
  }, [_c('i', {
    staticClass: "pi pi-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.orpSuggestion && _vm.orpSuggestion.cid ? _vm.$t('login.login') : _vm.$t('signup.back')))])])]) : _vm.step === 'otp' ? _c('span', {
    staticClass: "back-link",
    on: {
      "click": _vm.goBackToForm
    }
  }, [_c('i', {
    staticClass: "pi pi-arrow-left"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('signup.changeEmail')))])]) : _vm._e()], 1), _vm._v(" "), _c('section', [_c('h2', [_vm._v(_vm._s(_vm.$t('signup.signup')))]), _vm._v(" "), _c('div', {
    staticClass: "signup__content"
  }, [_vm.step === 'form' ? _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "field half-field"
  }, [_c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v(_vm._s(_vm.$t('signup.firstName')) + " *")]), _vm._v(" "), _c('InputText', {
    class: {
      'p-invalid': _vm.submitTried && (_vm.firstName === '' || _vm.firstNameError)
    },
    attrs: {
      "id": "firstName",
      "placeholder": _vm.$t('signup.firstNamePlaceholder'),
      "aria-required": true,
      "aria-invalid": _vm.submitTried && (_vm.firstName === '' || !!_vm.firstNameError)
    },
    on: {
      "input": function ($event) {
        _vm.firstNameError = '';
      }
    },
    model: {
      value: _vm.firstName,
      callback: function ($$v) {
        _vm.firstName = $$v;
      },
      expression: "firstName"
    }
  }), _vm._v(" "), _vm.submitTried && (_vm.firstName === '' || _vm.firstNameError) ? _c('small', [_vm._v("\n            " + _vm._s(_vm.firstName === '' ? _vm.$t('signup.fieldRequired') : _vm.firstNameError) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field half-field"
  }, [_c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v(_vm._s(_vm.$t('signup.lastName')) + " *")]), _vm._v(" "), _c('InputText', {
    class: {
      'p-invalid': _vm.submitTried && (_vm.lastName === '' || _vm.lastNameError)
    },
    attrs: {
      "id": "lastName",
      "placeholder": _vm.$t('signup.lastNamePlaceholder'),
      "aria-required": true,
      "aria-invalid": _vm.submitTried && (_vm.lastName === '' || !!_vm.lastNameError)
    },
    on: {
      "input": function ($event) {
        _vm.lastNameError = '';
      }
    },
    model: {
      value: _vm.lastName,
      callback: function ($$v) {
        _vm.lastName = $$v;
      },
      expression: "lastName"
    }
  }), _vm._v(" "), _vm.submitTried && (_vm.lastName === '' || _vm.lastNameError) ? _c('small', [_vm._v("\n            " + _vm._s(_vm.lastName === '' ? _vm.$t('signup.fieldRequired') : _vm.lastNameError) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.email')) + " *")]), _vm._v(" "), _c('InputText', {
    class: {
      'p-invalid': _vm.submitTried && (_vm.email === '' || _vm.emailError)
    },
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": _vm.$t('signup.emailPlaceholder'),
      "aria-required": true,
      "aria-invalid": _vm.submitTried && (_vm.email === '' || _vm.emailError)
    },
    on: {
      "input": function ($event) {
        _vm.emailError = '';
      }
    },
    model: {
      value: _vm.email,
      callback: function ($$v) {
        _vm.email = $$v;
      },
      expression: "email"
    }
  }), _vm._v(" "), _vm.submitTried && (_vm.email === '' || _vm.emailError) ? _c('small', [_vm._v("\n            " + _vm._s(_vm.email === '' ? _vm.$t('signup.fieldRequired') : _vm.emailError) + "\n          ")]) : _vm._e()], 1), _vm._v(" "), _c('client-only', [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('settings.phoneNumber')) + " *")]), _vm._v(" "), _c('VuePhoneNumberInput', {
    attrs: {
      "translations": _vm.$t('settings.phone'),
      "fetch-country": true,
      "required": "",
      "error": _vm.submitTried && (!_vm.phoneNumber || !_vm.phoneIsValid)
    },
    on: {
      "update": _vm.updatePhoneNumber
    },
    model: {
      value: _vm.phoneNumber,
      callback: function ($$v) {
        _vm.phoneNumber = $$v;
      },
      expression: "phoneNumber"
    }
  }), _vm._v(" "), _vm.submitTried && !_vm.phoneNumber ? _c('small', [_vm._v(_vm._s(_vm.$t('signup.fieldRequired')))]) : _vm.submitTried && !_vm.phoneIsValid ? _c('small', [_vm._v(_vm._s(_vm.$t('settings.phoneNotValid')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "policy",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.terms1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "field checkbox"
  }, [_c('Checkbox', {
    attrs: {
      "id": "terms2",
      "binary": true
    },
    model: {
      value: _vm.terms2,
      callback: function ($$v) {
        _vm.terms2 = $$v;
      },
      expression: "terms2"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "terms2"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.terms2'))
    }
  })], 1), _vm._v(" "), _vm.error ? _c('small', {
    staticStyle: {
      "margin": "auto"
    },
    domProps: {
      "textContent": _vm._s(_vm.error)
    }
  }) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "label": _vm.$t('login.signup'),
      "aria-label": "Sign up"
    },
    on: {
      "click": _vm.registerUser
    }
  })], 1) : _vm.step === 'otp' ? _c('div', {
    staticClass: "otp-verification"
  }, [_c('div', {
    staticClass: "otp-verification__header"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "65",
      "height": "64",
      "viewBox": "0 0 65 64",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M51.166 11.333H13.8327C12.5972 11.34 11.4142 11.8339 10.5406 12.7076C9.66693 13.5812 9.17302 14.7642 9.16602 15.9997V47.9997C9.17302 49.2352 9.66693 50.4181 10.5406 51.2918C11.4142 52.1654 12.5972 52.6593 13.8327 52.6663H51.166C52.4015 52.6593 53.5845 52.1654 54.4581 51.2918C55.3318 50.4181 55.8257 49.2352 55.8327 47.9997V15.9997C55.8257 14.7642 55.3318 13.5812 54.4581 12.7076C53.5845 11.8339 52.4015 11.34 51.166 11.333ZM13.8327 15.333H51.166C51.3428 15.333 51.5124 15.4032 51.6374 15.5283C51.7624 15.6533 51.8327 15.8229 51.8327 15.9997V20.1063L32.4993 29.7597L13.166 20.1063V15.9997C13.166 15.8229 13.2363 15.6533 13.3613 15.5283C13.4863 15.4032 13.6559 15.333 13.8327 15.333ZM51.166 48.6663H13.8327C13.6559 48.6663 13.4863 48.5961 13.3613 48.4711C13.2363 48.3461 13.166 48.1765 13.166 47.9997V24.5597L31.5927 33.7863C31.8742 33.9271 32.1846 34.0005 32.4993 34.0005C32.8141 34.0005 33.1245 33.9271 33.406 33.7863L51.8327 24.5597V47.9997C51.8327 48.1765 51.7624 48.3461 51.6374 48.4711C51.5124 48.5961 51.3428 48.6663 51.166 48.6663Z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "otp-verification__title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('signup.verifyEmail')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "otp-verification__description"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('signup.otpSentTo', {
    email: _vm.email
  })) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "otp-verification__input"
  }, [_c('OtpInput', {
    ref: "otpInput",
    attrs: {
      "error": !!_vm.otpError,
      "disabled": _vm.otpLoading
    },
    on: {
      "input": _vm.handleOtpInput,
      "complete": _vm.verifyOtp
    },
    model: {
      value: _vm.otp,
      callback: function ($$v) {
        _vm.otp = $$v;
      },
      expression: "otp"
    }
  }), _vm._v(" "), _vm.otpError ? _c('small', {
    staticClass: "otp-error"
  }, [_vm._v(_vm._s(_vm.otpError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "otp-verification__timer"
  }, [_vm.otpRemainingTime > 0 ? _c('small', {
    staticClass: "otp-timer"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('signup.otpExpiresIn', {
    time: _vm.formatOtpTime
  })) + "\n          ")]) : _c('small', {
    staticClass: "otp-expired"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('signup.otpExpired')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "otp-verification__actions"
  }, [_c('Button', {
    staticClass: "p-button-text resend-button",
    attrs: {
      "label": _vm.$t('signup.resendOtp'),
      "disabled": _vm.otpLoading || _vm.otpRemainingTime > 0
    },
    on: {
      "click": _vm.resendOtp
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticClass: "verify-button",
    attrs: {
      "label": _vm.$t('signup.verifyOtpButton'),
      "loading": _vm.otpLoading,
      "disabled": _vm.otpLoading || _vm.otp.length !== 6
    },
    on: {
      "click": _vm.verifyOtp
    }
  })], 1) : _vm.step === 'success' ? _c('div', {
    staticClass: "thankyou"
  }, [!_vm.orp ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('signup.registrationCompleted')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('signup.welcomeMessage')))])]) : _c('div', {
    staticClass: "thankyou-after-orp"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "65",
      "height": "64",
      "viewBox": "0 0 65 64",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M51.166 11.333H13.8327C12.5972 11.34 11.4142 11.8339 10.5406 12.7076C9.66693 13.5812 9.17302 14.7642 9.16602 15.9997V47.9997C9.17302 49.2352 9.66693 50.4181 10.5406 51.2918C11.4142 52.1654 12.5972 52.6593 13.8327 52.6663H51.166C52.4015 52.6593 53.5845 52.1654 54.4581 51.2918C55.3318 50.4181 55.8257 49.2352 55.8327 47.9997V15.9997C55.8257 14.7642 55.3318 13.5812 54.4581 12.7076C53.5845 11.8339 52.4015 11.34 51.166 11.333ZM13.8327 15.333H51.166C51.3428 15.333 51.5124 15.4032 51.6374 15.5283C51.7624 15.6533 51.8327 15.8229 51.8327 15.9997V20.1063L32.4993 29.7597L13.166 20.1063V15.9997C13.166 15.8229 13.2363 15.6533 13.3613 15.5283C13.4863 15.4032 13.6559 15.333 13.8327 15.333ZM51.166 48.6663H13.8327C13.6559 48.6663 13.4863 48.5961 13.3613 48.4711C13.2363 48.3461 13.166 48.1765 13.166 47.9997V24.5597L31.5927 33.7863C31.8742 33.9271 32.1846 34.0005 32.4993 34.0005C32.8141 34.0005 33.1245 33.9271 33.406 33.7863L51.8327 24.5597V47.9997C51.8327 48.1765 51.7624 48.3461 51.6374 48.4711C51.5124 48.5961 51.3428 48.6663 51.166 48.6663Z",
      "fill": "#003263"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "almostthere",
    domProps: {
      "textContent": _vm._s(_vm.$t('signup.almostThere'))
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('signup.toInvite'))
    }
  })])]) : _vm._e()])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }